const SERVICES = [
  {
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 10V3L4 14h7v7l9-11h-7z" />
      </svg>
    ),
    title: "Refonte technique",
    description:
      "Stack moderne, Core Web Vitals au vert. Astro 6 + Tailwind 4, hébergement Cloudflare edge. La même stack que celle de levier-ia.fr — auditez-la.",
    features: ["Astro 6 + TypeScript", "Cloudflare Workers edge", "< 1 s LCP / 95+ Lighthouse", "Responsive mobile-first"],
  },
  {
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
      </svg>
    ),
    title: "SEO 2026",
    description:
      "Pensé pour Google après les Helpful Content Updates. Schema.org JSON-LD, maillage interne, hreflang FR/EN, Search Console & Bing Webmaster configurés.",
    features: ["JSON-LD (Org, Article, FAQ, Product)", "Hreflang FR/EN", "Sitemap segmenté", "Core Web Vitals validés"],
  },
  {
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
      </svg>
    ),
    title: "GEO — le différenciateur",
    description:
      "Apparaissez dans ChatGPT, Perplexity, Gemini. Carte topique 3×3, llms.txt, FAQ extractive Question-H2, pages /ai/ noindex pour LLM crawlers, ouverture à 14 bots IA.",
    features: ["llms.txt + llms-full.txt", "Carte topique 9 cellules", "FAQ extractive (40 mots)", "Ouverture aux 14 crawlers IA"],
  },
];

export function Services() {
  return (
    <section id="services" className="py-24 px-6 bg-slate-950">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-sm font-semibold text-blue-400 uppercase tracking-wider mb-3">
            Méthode Levier
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold text-white">
            Si l'audit révèle un besoin — voici ce qu'on livre
          </h2>
          <p className="mt-4 text-slate-400 max-w-2xl mx-auto">
            L'audit gratuit qualifie d'abord votre site. Si une intervention est
            recommandée, on livre une refonte ciblée en <strong className="text-white">5 jours ouvrés</strong> —
            SEO classique + GEO (ChatGPT, Perplexity, Gemini) + schema.org.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {SERVICES.map((service) => (
            <div
              key={service.title}
              className="group relative p-8 bg-slate-800/50 border border-slate-700/50 rounded-2xl hover:border-blue-500/50 hover:bg-slate-800/80 transition-all duration-300"
            >
              {/* Glow effect on hover */}
              <div className="absolute -inset-px bg-gradient-to-b from-blue-500/10 to-transparent rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

              <div className="relative">
                <div className="inline-flex items-center justify-center w-14 h-14 rounded-xl bg-blue-500/10 text-blue-400 mb-6 group-hover:bg-blue-500/20 transition-colors duration-300">
                  {service.icon}
                </div>

                <h3 className="text-xl font-semibold text-white mb-3">
                  {service.title}
                </h3>

                <p className="text-slate-400 mb-6 leading-relaxed">
                  {service.description}
                </p>

                <ul className="space-y-2">
                  {service.features.map((feature) => (
                    <li key={feature} className="flex items-center gap-2 text-sm text-slate-300">
                      <svg className="w-4 h-4 text-blue-500 shrink-0" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* Proof block — the method is publicly applied to our own site */}
        <div className="mt-12 p-6 rounded-2xl bg-gradient-to-r from-blue-900/30 to-indigo-900/30 border border-blue-500/30 max-w-3xl mx-auto">
          <p className="text-center text-slate-200 leading-relaxed">
            <span className="inline-block mr-2 text-xl" aria-hidden>📍</span>
            <strong className="text-white">La preuve ?</strong> Cette méthode est appliquée à notre propre site. Vérifiez :{" "}
            <a
              href="https://levier-ia.fr/topics"
              target="_blank"
              rel="noopener"
              className="text-blue-300 hover:text-blue-200 underline underline-offset-2"
            >
              levier-ia.fr/topics
            </a>{" "}
            ·{" "}
            <a
              href="https://levier-ia.fr/llms.txt"
              target="_blank"
              rel="noopener"
              className="text-blue-300 hover:text-blue-200 underline underline-offset-2"
            >
              /llms.txt
            </a>{" "}
            ·{" "}
            <a
              href="https://levier-ia.fr/ai/faq"
              target="_blank"
              rel="noopener"
              className="text-blue-300 hover:text-blue-200 underline underline-offset-2"
            >
              /ai/faq
            </a>
            .
          </p>
        </div>
      </div>
    </section>
  );
}
